module.exports = __webpack_public_path__ + "static/media/check_blue.f6230d0b.svg";